import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { ReactComponent as Location } from 'assets/icon/location.svg';
import { observer } from 'mobx-react-lite';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';

const MissingServicesModal = observer(
  ({
    isOpen,
    close,
    onProceedToCheckout,
  }: {
    isOpen: boolean;
    close: () => void;
    onProceedToCheckout: () => void;
  }) => {
    const cart = useCartContext();
    return (
      <>
        <Modal
          isVisible={isOpen}
          close={close}
          className="min-w-full max-w-[624px] bg-background-base-surface-2 md:min-w-[624px]"
          enableScrolling={true}
        >
          <div className="flex flex-col gap-8 px-8 pt-8">
            <h1 className="space-2 text-2xl font-bold text-content-base-default">
              Locations missing services
              <p className="text-base font-semibold text-content-base-subdued">
                The following locations do not have any services selected. Only
                locations with services will be included in your order.
              </p>
            </h1>
            <div className="flex flex-col gap-4">
              {cart.locationMissingServices.map((loc) => (
                <div className="flex gap-2" key={loc.id}>
                  <Location />
                  <p className="text-sm font-semibold text-content-base-default">
                    {loc.address_line_1}, {loc.city}, {loc.state} {loc.zip}
                  </p>
                </div>
              ))}
            </div>
            <p className="text-base font-semibold text-content-base-subdued">
              Would you like to go back and add services, or proceed to
              checkout?
            </p>
          </div>
          <div className="mt-12 flex gap-4 px-8 pb-8">
            <GraniteButton size="large" variant="secondary" onClick={close}>
              Go Back
            </GraniteButton>
            <GraniteButton size="large" onClick={onProceedToCheckout}>
              Proceed to checkout
            </GraniteButton>
          </div>
        </Modal>
      </>
    );
  },
);

export default MissingServicesModal;
